/* FRÈRES — Favoritos (wishlist)
   Capa 1: localStorage. Guarda un snapshot por producto para renderizar
   la página /favoritos sin fetches. Estructurado para sumar sync a
   Firebase cuando el cliente esté logueado (capa 2).

   API pública: window.frFavorites = { get, has, toggle, refresh }
*/
(function () {
  'use strict';

  var STORAGE_KEY = 'fr_favorites_v1';

  /* ---------- almacenamiento ---------- */
  function read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function write(arr) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('fr:favorites:change', { detail: { items: arr } }));
  }

  function has(id) {
    id = String(id);
    return read().some(function (it) { return String(it.id) === id; });
  }

  function snapshotFromButton(btn) {
    return {
      id: btn.getAttribute('data-product-id'),
      handle: btn.getAttribute('data-product-handle'),
      url: btn.getAttribute('data-product-url'),
      title: btn.getAttribute('data-product-title'),
      image: btn.getAttribute('data-product-image'),
      priceCents: parseInt(btn.getAttribute('data-product-price'), 10) || 0,
      priceVaries: btn.getAttribute('data-product-price-varies') === 'true',
      available: btn.getAttribute('data-product-available') === 'true',
      addedAt: Date.now()
    };
  }

  /* ---------- formato de precio (Shopify money_format) ---------- */
  var MONEY_FORMAT = window.frMoneyFormat || '${{amount_no_decimals_with_comma_separator}}';
  function formatMoney(cents) {
    cents = Number(cents) || 0;
    var m = MONEY_FORMAT.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return MONEY_FORMAT;
    function withDelims(num, precision, thousands, decimal) {
      num = (num / 100).toFixed(precision);
      var parts = num.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var value;
    switch (m[1]) {
      case 'amount': value = withDelims(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = withDelims(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelims(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelims(cents, 0, ' ', ''); break;
      default: value = withDelims(cents, 2, ',', '.');
    }
    return MONEY_FORMAT.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function toggle(snapshot) {
    var arr = read();
    var id = String(snapshot.id);
    var idx = arr.findIndex(function (it) { return String(it.id) === id; });
    var nowActive;
    if (idx === -1) {
      arr.unshift(snapshot);
      nowActive = true;
    } else {
      arr.splice(idx, 1);
      nowActive = false;
    }
    write(arr);
    return nowActive;
  }

  function removeById(id) {
    id = String(id);
    write(read().filter(function (it) { return String(it.id) !== id; }));
  }

  /* ---------- UI: botones de corazón ---------- */
  function paintButton(btn) {
    var active = has(btn.getAttribute('data-product-id'));
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    var label = active ? 'Quitar de favoritos' : 'Agregar a favoritos';
    btn.setAttribute('aria-label', label);
    btn.setAttribute('title', label);
  }

  function refresh() {
    document.querySelectorAll('[data-fr-fav-toggle]').forEach(paintButton);
    updateCount();
    renderPage();
  }

  function onClick(e) {
    var btn = e.target.closest('[data-fr-fav-toggle]');
    if (!btn) return;
    e.preventDefault();
    var active = toggle(snapshotFromButton(btn));
    btn.classList.add('fr-fav--bump');
    setTimeout(function () { btn.classList.remove('fr-fav--bump'); }, 320);
    // repintar todos los botones del mismo producto que estén en pantalla
    var id = btn.getAttribute('data-product-id');
    document.querySelectorAll('[data-fr-fav-toggle][data-product-id="' + id + '"]').forEach(paintButton);
    updateCount();
  }

  /* ---------- contador del header ---------- */
  function updateCount() {
    var n = read().length;
    document.querySelectorAll('[data-fr-fav-count]').forEach(function (el) {
      el.textContent = n > 0 ? n : '';
      el.classList.toggle('is-empty', n === 0);
    });
    document.querySelectorAll('[data-fr-fav-link]').forEach(function (el) {
      el.classList.toggle('has-favs', n > 0);
      el.setAttribute('aria-label', n > 0 ? 'Mis favoritos (' + n + ')' : 'Mis favoritos');
    });
  }

  /* ---------- página /favoritos ---------- */
  function renderPage() {
    var root = document.querySelector('[data-fr-fav-page]');
    if (!root) return;
    var grid = root.querySelector('[data-fr-fav-grid]');
    var empty = root.querySelector('[data-fr-fav-empty]');
    var items = read();

    if (!items.length) {
      if (grid) grid.innerHTML = '';
      if (empty) empty.hidden = false;
      root.classList.add('is-empty');
      return;
    }
    root.classList.remove('is-empty');
    if (empty) empty.hidden = true;
    if (!grid) return;

    grid.innerHTML = items.map(function (it) {
      var soldout = it.available === false;
      return (
        '<div class="fr-fav-card" data-fr-fav-card data-product-id="' + esc(it.id) + '">' +
          '<button type="button" class="fr-fav-card__remove" data-fr-fav-remove="' + esc(it.id) + '" aria-label="Quitar de favoritos">&times;</button>' +
          '<a class="fr-fav-card__media" href="' + esc(it.url) + '">' +
            (it.image ? '<img src="' + esc(it.image) + '" alt="' + esc(it.title) + '" loading="lazy">' : '<span class="fr-fav-card__ph"></span>') +
            (soldout ? '<span class="fr-fav-card__soldout">Agotado</span>' : '') +
          '</a>' +
          '<a class="fr-fav-card__title" href="' + esc(it.url) + '">' + esc(it.title) + '</a>' +
          '<div class="fr-fav-card__price">' + (it.priceVaries ? 'Desde ' : '') + esc(formatMoney(it.priceCents)) + '</div>' +
        '</div>'
      );
    }).join('');

    revalidate(items, grid);
  }

  /* ---------- revalidar precio/stock contra el producto real ---------- */
  function revalidate(items, grid) {
    items.forEach(function (it) {
      if (!it.handle) return;
      fetch('/products/' + it.handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var changed = false;
          if (typeof p.available === 'boolean' && p.available !== it.available) { it.available = p.available; changed = true; }
          if (typeof p.price === 'number' && p.price !== it.priceCents) { it.priceCents = p.price; changed = true; }
          if (typeof p.price_varies === 'boolean' && p.price_varies !== it.priceVaries) { it.priceVaries = p.price_varies; changed = true; }
          if (!changed) return;

          // persistir el snapshot actualizado
          var all = read();
          var idx = all.findIndex(function (x) { return String(x.id) === String(it.id); });
          if (idx !== -1) { all[idx] = it; write(all); }

          // actualizar la card en pantalla
          var card = grid.querySelector('[data-fr-fav-card][data-product-id="' + it.id + '"]');
          if (!card) return;
          var priceEl = card.querySelector('.fr-fav-card__price');
          if (priceEl) priceEl.textContent = (it.priceVaries ? 'Desde ' : '') + formatMoney(it.priceCents);
          var media = card.querySelector('.fr-fav-card__media');
          var badge = card.querySelector('.fr-fav-card__soldout');
          if (it.available === false && !badge && media) {
            var s = document.createElement('span');
            s.className = 'fr-fav-card__soldout';
            s.textContent = 'Agotado';
            media.appendChild(s);
          } else if (it.available !== false && badge) {
            badge.remove();
          }
        })
        .catch(function () {});
    });
  }

  function onPageClick(e) {
    var rm = e.target.closest('[data-fr-fav-remove]');
    if (!rm) return;
    e.preventDefault();
    var grid = document.querySelector('[data-fr-fav-grid]');
    var buttons = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-fr-fav-remove]')) : [];
    var idx = buttons.indexOf(rm);

    removeById(rm.getAttribute('data-fr-fav-remove'));
    refresh();

    var status = document.querySelector('[data-fr-fav-status]');
    if (status) status.textContent = 'Producto quitado de favoritos.';

    // devolver el foco a un lugar lógico (no perderlo al <body>)
    var newButtons = grid ? grid.querySelectorAll('[data-fr-fav-remove]') : [];
    if (newButtons.length) {
      var target = newButtons[Math.min(idx, newButtons.length - 1)];
      if (target) target.focus();
    } else {
      var heading = document.querySelector('.fr-fav-page__title');
      if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus(); }
    }
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ---------- arranque ---------- */
  function init() {
    document.addEventListener('click', onClick);
    document.addEventListener('click', onPageClick);

    // re-pintar cuando entran cards nuevas (scroll infinito / filtros)
    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        document.querySelectorAll('[data-fr-fav-toggle]:not(.fr-fav--seen)').forEach(function (b) {
          b.classList.add('fr-fav--seen');
          paintButton(b);
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });

    // sincronizar entre pestañas
    window.addEventListener('storage', function (e) {
      if (e.key === STORAGE_KEY) refresh();
    });

    refresh();
  }

  window.frFavorites = { get: read, has: has, toggle: toggle, refresh: refresh };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
